module.exports = __webpack_public_path__ + "img/quick_bk.b7dbd693.png";